import sliderLayoutController from '../global/sliderLayoutController';

const valueProposition = () => {
	const valueProposition = Array.from(document.getElementsByClassName("value-proposition"));
    
	if (valueProposition.length > 0) {
		sliderLayoutController('value-proposition__values-wrapper', 4, null, "full", '.value-proposition__prev', '.value-proposition__next');
	}
}

export default valueProposition;
